module.exports = __webpack_public_path__ + "img/zsktsgl.053ab93c.svg";